const initialState = {
    data: [],
  };
  
  const stawkiJednorazoweIndUReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_STAWKI_JEDNORAZOWE_IND_U':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default stawkiJednorazoweIndUReducer;